import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class OpenTracingInterceptor implements HttpInterceptor {
  public intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const uuid = this.generateUUID();

    request = request.clone({
      setHeaders: {
        'X-B3-TraceId': uuid,
        'X-B3-SpanId': uuid,
      },
    });

    return next.handle(request);
  }

  private generateUUID(): string {
    /* eslint-disable no-bitwise */
    const p0 = `00000000${Math.abs((Math.random() * 0xFFFFFFFF) | 0).toString(16)}`.substr(-8);
    const p1 = `00000000${Math.abs((Math.random() * 0xFFFFFFFF) | 0).toString(16)}`.substr(-8);
    return `${p0}${p1}`;
  }
}
